import React from 'react'
import { Log } from '@vt/comps'
import { useTbViewStore } from '@vt/hooks'
import { pick } from 'lodash-es'
import { Modal } from '@ow/comps'

const CustomLog = function () {
  const { tbData } = useTbViewStore((state) => pick(state, ['tbData']))

  return (
    <div className="md:h-full">
      <div className="hidden px-4 py-4 flex-col gap-4 md:show md:flex h-full">
        <div className="font-bold">打卡日志</div>
        <div
          className="overflow-y-auto"
          style={{ height: 'calc(100% - 20px)' }}
        >
          <Log data={tbData.length !== 0 ? tbData[0] : {}} />
        </div>
      </div>
      <div className="md:hidden px-3 py-4 flex justify-between items-center">
        <div className="font-bold">打卡日志</div>
        <Modal
          trigger={
            <div className="text-sm text-neutral-700">查看详情 &gt;</div>
          }
          showCloseButton
          isFullScreen
          title="打卡日志"
        >
          <div className="overflow-y-auto" style={{ height: '100%' }}>
            <Log data={tbData.length !== 0 ? tbData[0] : {}} />
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default CustomLog
